import { api } from "../../../../../services/api";

export async function sendEmail(data) {
  await api.post("/sendEmails/inoveClubeShopkeeperContact", { ...data });
}
